import React from "react";
import Box from "@mui/material/Box";
import { legalLinkSx, MF_PRIVACY_URL, MF_TERMS_URL } from "../../utils/legalLinks";

/**
 * Privacy · Terms strip used on /login and /signup.
 * Uses the shared legalLinkSx token so color/size stay in sync.
 */
export default function AuthLegalStrip({ sx: sxProp }) {
  return (
    <Box
      sx={{
        fontSize: "11px",
        color: "var(--color-text-tertiary)",
        textAlign: "center",
        pt: 1,
        ...sxProp,
      }}
    >
      <Box
        component="a"
        href={MF_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={legalLinkSx}
      >
        Privacy
      </Box>
      {" · "}
      <Box
        component="a"
        href={MF_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        sx={legalLinkSx}
      >
        Terms
      </Box>
    </Box>
  );
}
